import React, { Fragment, useEffect, useState } from 'react'
import Card from '../../../../components/ui/Card'
import { Button } from 'components/ui'
import { App } from 'realm-web'
import useNewrelic from 'utils/hooks/useNewrelic'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import subscriptions from './dw_subscriptions.json'
import { useTranslation } from 'react-i18next'

function DWSubscriptions() {
    const app = new App({ id: process.env.REACT_APP_APP_ID })
    // const [subscriptions, setSubscriptions] = useState()

    const { NrAgent } = useNewrelic()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const user = useSelector((state) => state.auth.user)
    const lang = useSelector((state) => state.locale.currentLang)

    /*
    ************************************* LEFT TODO'S ********************************
    Todo 1: Payment system is not integrated
    Todo 2: While setting payment system we will send subscription id into transactions and stored it in purchases collection
    Todo 3: We will get transaction obj after successfull transaction that will contains transaction_id, transaction_type_reference etc.
    Todo 4: We will pass transaction_id into handleSubscriptionPlanSet fn to update user doc
    */
    const currentPurchase = {
        transaction_id: 'abc-123-ks-6552',
        transaction_type: 'subscription',
        transaction_time: new Date(),
        amount: 10,
        currency: 'USD',
        payment: {
            type: 'PayPal',
            reference: 'payment_id',
        },
    }

    const transactionId = currentPurchase.transaction_id

    // Checking that whether user is signed in or not

    const checkUserSignInStatus = async (user) => {
        try {
            if (user.name || user.email) {
                alert('Payement process is coming soon.....')
                return true
            } else {
                alert('Please continue to sign in.....')
                navigate(`/auth/${lang}/sign-in-simple`)
                return false
            }
        } catch (err) {
            NrAgent.noticeError(err)
            return false
        }
    }

    const handleSubscriptionPlanSet = async (
        // transaction Id
        transactionId,
        transaction_type_reference
    ) => {
        try {
            const isUserAuthenticated = await checkUserSignInStatus(user)
            if (isUserAuthenticated) {
                // We will not call this function this is just for testing purposes for now
                currentPurchase.transaction_type_reference =
                    transaction_type_reference
                await app.currentUser.functions.fn_subscriptions_purchases_create(
                    currentPurchase
                )

                const userSubscriptionSet =
                    await app.currentUser.functions.fn_user_subscriptions_set(
                        // Todo 1 : Pass in the transaction Id
                        transactionId
                    )
            }
        } catch (err) {
            NrAgent.noticeError(err)
        }
    }

    return (
        <Fragment>
            <Card className="mb-20">
                <h1 className="flex justify-center items-center pt-10">
                    {t('dwSubscriptions:content.heading')}
                </h1>
                <div className="flex flex-wrap justify-around items-start  mt-8">
                    {subscriptions?.map((subscription) => {
                        return (
                            <Card
                                key={subscription.name}
                                clickable
                                className="mb-20 w-screen sm:w-screen md:w-screen lg:w-72 xl:w-80 2xl:w-96 hover:shadow-lg transition duration-150 ease-in-out dark:border dark:border-gray-600 dark:border-solid mt-8"
                            >
                                <div className="h-auto overflow-hidden max-w-screen sm:max-w-screen md:max-w-screen  border border-gray-300 shadow-sm p-6 rounded-lg ">
                                    <div className="flex flex-col justify-center items-center">
                                        <h2 className="text-2xl font-semibold ">
                                            {subscription.name}
                                        </h2>
                                        <p className=" mt-2">
                                            {t(
                                                'dwSubscriptions:content.welcomeToTruYu'
                                            )}
                                        </p>

                                        <div className="h-12 mt-4">
                                            <p className="text-3xl font-semibold ">
                                                ${subscription.price.amount}
                                                <span className="text-lg ">
                                                    {
                                                        subscription.price
                                                            .frequency
                                                    }
                                                </span>
                                            </p>
                                        </div>
                                        <ul className="h-28 mt-4 ">
                                            {subscription?.product_access?.map(
                                                (product) => {
                                                    return (
                                                        <li
                                                            className="flex items-center"
                                                            key={product.code}
                                                        >
                                                            <svg
                                                                className="w-5 h-5 mr-2 text-green-600"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth="2"
                                                                viewBox="0 0 24 24"
                                                            >
                                                                <path d="M5 12l5 5L19 7"></path>
                                                            </svg>
                                                            {product.code}
                                                        </li>
                                                    )
                                                }
                                            )}
                                        </ul>
                                    </div>
                                    <Button
                                        variant="solid"
                                        className="bg-blue-500 text-white mt-6 py-2 px-4 rounded-full w-full hover:bg-blue-600 transition duration-300 ease-in-out transform "
                                        onClick={() =>
                                            handleSubscriptionPlanSet(
                                                transactionId,
                                                subscription.subscription_id
                                            )
                                        }
                                    >
                                        {t(
                                            'dwSubscriptions:content.selectPlan'
                                        )}
                                    </Button>
                                </div>
                            </Card>
                        )
                    })}
                </div>
            </Card>
        </Fragment>
    )
}

export default DWSubscriptions
